import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { HelpMenuItemsProvider } from '../../help-menu-items.provider'

@Component({
  selector: 'ftr-help-sub-menu-flyout-card',
  templateUrl: './help-sub-menu-flyout-card.component.html',
  styleUrl: './help-sub-menu-flyout-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HelpSubMenuFlyoutCardComponent {
  private readonly helpMenuItemsProvider = inject(HelpMenuItemsProvider)

  courtSystemId = input<Uuid | undefined>(undefined)

  protected readonly items = computed(() => this.helpMenuItemsProvider.provide(this.courtSystemId())())
}
